export const BASE_URL = "https://auth.teamtrust.me";
export const ENV = "dev";

